module.exports = __webpack_public_path__ + "img/up_top.b8140473.png";